import styled from "../../__compat__/styled-components/main.entry.mjs.mjs";
import React from "../../__compat__/react/main.entry.mjs.mjs";
import { SkeletonShape } from "../SkeletonShape/SkeletonShape.mjs.mjs";
import { ButtonSkeleton, TextSkeleton } from "../index.mjs.mjs";
const StyledContentContainer = styled.div.withConfig({ displayName: "auir-611444a-StyledContentContainer", componentId: "auir-611444a-srfra" }) `
  display: flex;
  flex-direction: column;
  padding: var(${(props) => props.theme.responsive.spacing.l});
`;
const StyledTextWrapper = styled.div.withConfig({ displayName: "auir-611444a-StyledTextWrapper", componentId: "auir-611444a-1x9eh13" }) `
  max-width: 800px;
`;
export const ProductTileSkeleton = () => (React.createElement("div", null,
    React.createElement(SkeletonShape, { variant: "rectangular", width: "100%", aspectRatio: "4/3" }),
    React.createElement(StyledContentContainer, null,
        React.createElement(StyledTextWrapper, null,
            React.createElement(TextSkeleton, { width: "100%", lines: 1, variant: "order4", spacing: [, , 'xxs'] }),
            React.createElement(TextSkeleton, { width: "65%", lines: 1, variant: "copy2", spacing: [, , 'm'] }),
            React.createElement(TextSkeleton, { width: "50%", lines: 1, variant: "copy1", spacing: [, , 'm'] }),
            React.createElement(TextSkeleton, { width: "100", lines: 1, variant: "copy2", spacing: [, , 'm'] })),
        React.createElement(ButtonSkeleton, { variant: "primary", width: "100%" }))));
//# sourceMappingURL=ProductTile.skeleton.mjs.mjs.map